import React from 'react';
import { Box, Button, TextField, Typography, InputAdornment, IconButton, Link } from '@mui/material';
import { Visibility, VisibilityOff, ArrowBack } from '@mui/icons-material';

export default function SignupForm({
    formData,
    onInputChange,
    onSubmit,
    onBack,
    showPassword,
    showConfirmPassword,
    onTogglePassword,
    onToggleConfirmPassword,
    mode
}) {
    return (
        <form onSubmit={onSubmit} style={{ width: '100%' }}>
            <Box sx={{ 
                position: 'relative', 
                mb: 3,
                mt: -1
            }}>
                <IconButton
                    onClick={onBack}
                    sx={{ 
                        color: '#2B0063',
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        p: 1,
                        '&:hover': {
                            background: 'none',
                            opacity: 0.8
                        }
                    }}
                >
                    <ArrowBack />
                </IconButton>
                <Typography variant="h6" align="center" gutterBottom>
                    Sign Up
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <TextField
                    name="barName"
                    type="text"
                    label="Bar Name"
                    value={formData.barName}
                    onChange={onInputChange}
                    fullWidth
                    required
                    sx={{ mb: 2 }}
                />
                <TextField
                    name="email"
                    type="email"
                    label="Email"
                    value={formData.email}
                    onChange={onInputChange}
                    fullWidth
                    required
                    sx={{ mb: 2 }}
                />
                <TextField
                    name="password"
                    type={showPassword ? 'text' : 'password'}
                    label="Password"
                    value={formData.password}
                    onChange={onInputChange}
                    fullWidth
                    required
                    sx={{ mb: 2 }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={onTogglePassword}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
                <TextField
                    name="confirmPassword"
                    type={showConfirmPassword ? 'text' : 'password'}
                    label="Confirm Password"
                    value={formData.confirmPassword}
                    onChange={onInputChange}
                    fullWidth
                    required
                    sx={{ mb: 2 }}
                    error={formData.password !== formData.confirmPassword && formData.confirmPassword !== ''}
                    helperText={
                        formData.password !== formData.confirmPassword && formData.confirmPassword !== '' 
                            ? 'Passwords do not match' 
                            : ''
                    }
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={onToggleConfirmPassword}
                                    edge="end"
                                >
                                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
                <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    sx={{ 
                        mt: 2,
                        bgcolor: '#2B0063',
                        '&:hover': {
                            bgcolor: '#1a003d'
                        }
                    }}
                >
                    Sign Up
                </Button>
                <Typography color="textSecondary" align="center" sx={{ mt: 2 }}>
                    Not authorized? Contact us at{' '}
                    <Link
                        href="mailto:operations@lastcallforbars.com"
                        sx={{ 
                            color: '#2B0063',
                            textDecoration: 'none',
                            fontWeight: 'bold',
                            '&:hover': {
                                textDecoration: 'underline'
                            }
                        }}
                    >
                        here
                    </Link>
                    {' '}to get started.
                </Typography>
            </Box>
        </form>
    );
} 